
import Router from './jsx/router'
import { SnackbarProvider, enqueueSnackbar } from 'notistack';



function App() {
  return (
    <>
      
      <Router />
      
    </>
  );
}

export default App;
